<div class="print-page" [attr.dir]="dir">
  <ng-container *ngIf="loaded && prescription">

      <div class="rx-header">
          <div [innerHtml]="altHeader" *ngIf="altHeader"></div>
          <div *ngIf="!altHeader && env && env['haslogo']" style="margin-bottom: 0.8em;">
              <img src="/api/logo" alt="Logo" style="max-height: 80px; max-width: 100%;" />
            </div>
            <h1 class="rx-title">{{ lbl.title }}</h1>
        </div>
        <div class="rx-print-date">
          <!-- <span><strong>{{ lbl.date }}:</strong> {{ formatDateTime(prescription.CreatedAt) }}</span>
          &nbsp;&nbsp;|&nbsp;&nbsp; -->
          <span>{{ lang === 'he' ? 'תאריך הדפסה' : 'Print Date' }}: {{ printDate }}</span>
        </div>

    <div class="rx-patient">
      <div class="rx-field">
        <span class="rx-label">{{ lbl.name }}:</span>
        <span class="rx-value">{{ prescription.PatLast }} {{ prescription.PatFirst }}</span>
      </div>
      <div class="rx-field" *ngIf="prescription.PatIDNum">
        <span class="rx-label">{{ lbl.id }}:</span>
        <span class="rx-value">{{ prescription.PatIDNum }}</span>
      </div>
      <div class="rx-field" *ngIf="prescription.PatDOB">
        <span class="rx-label">{{ lbl.dob }}:</span>
        <span class="rx-value">{{ formatDate(prescription.PatDOB) }}</span>
      </div>
      <div class="rx-field" *ngIf="prescription.HMO">
        <span class="rx-label">{{ lbl.hmo }}:</span>
        <span class="rx-value">{{ getHMO(prescription.HMO) }}</span>
      </div>

    </div>

    <table class="rx-table" *ngIf="items && items.length > 0">
      <thead>
        <tr>
          <th>{{ lbl.drug }}</th>
          <th>{{ lbl.dosage }}</th>
          <th>{{ lbl.unit }}</th>
          <th>{{ lbl.route }}</th>
          <th>{{ lbl.timing }}</th>
          <th>{{ lbl.frequency }}</th>
          <th>{{ lbl.intervalValue }}</th>
          <th>{{ lbl.intervalUnit }}</th>
          <th>{{ lbl.instructions }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items">
          <td>
            <div class="drug-name">{{ lang === 'en' && item.DrugNameEn ? item.DrugNameEn : item.DrugName }}</div>
            <div class="drug-active" *ngIf="item.ActiveIngredient">{{ item.ActiveIngredient }}</div>
          </td>
          <td>{{ item.Dosage }}</td>
          <td>{{ unitLabel(item.Unit) }}</td>
          <td>{{ routeLabel(item.Route) }}</td>
          <td>{{ timingLabel(item.TimingCode) }}</td>
          <td>{{ frequencyLabel(item) }}</td>
          <td>{{ item.IntervalValue }}</td>
          <td>{{ item.IntervalValue ? intervalUnitLabel(item.IntervalUnit) : '' }}</td>
          <td>{{ item.Instructions }}</td>
        </tr>
      </tbody>
    </table>

    <div class="rx-footer">
      <div class="rx-narcotic-instructions" *ngIf="prescription.IsNarcotic && prescription.NarcoticInstructions">
        <span class="rx-label">{{ lbl.instructions }}:</span>
        <p class="rx-narcotic-text">{{ prescription.NarcoticInstructions }}</p>
      </div>

      <div class="rx-footer-row">
        <div class="rx-signed" *ngIf="prescription.Opener">
          <div>
            <span class="rx-label">{{ lbl.signedBy }}:</span>
            <span class="rx-value">{{ getSignerDisplay(prescription) }}</span>
          </div>
          <img *ngIf="doctorSignatureUrl" [src]="doctorSignatureUrl" class="rx-signature-img" alt="Signature">
        </div>
        <div class="rx-signed" *ngIf="prescription.IsNarcotic && prescription.DoctorID">
          <span class="rx-label">{{ lbl.doctorId }}:</span>
          <span class="rx-value">{{ prescription.DoctorID }}</span>
        </div>
        <div class="rx-signed" *ngIf="prescription.OpenerDrNum">
          <span class="rx-label">{{ lbl.licenseNum }}:</span>
          <span class="rx-value">{{ prescription.OpenerDrNum }}</span>
        </div>
        <div class="rx-signed" *ngIf="prescription.OpenerExpertNum">
          <span class="rx-label">{{ lbl.expertNum }}:</span>
          <span class="rx-value">{{ prescription.OpenerExpertNum }}</span>
        </div>
      </div>
      <!-- <div class="rx-signature-line"></div> -->
    </div>

  </ng-container>

  <!-- the PDF renderer waits for .finished before capturing the page -->
  @if (loaded) {
    <span class="finished"></span>
  }
  <div *ngIf="!loaded" class="rx-loading">...</div>
</div>
